import { forwardRef } from 'react';
import styled from '@emotion/styled';
import * as tokens from '@tokens';
import type { FieldBaseProps } from '../Field/FieldBase';
import { FieldBase } from '../Field/FieldBase';

export type FieldListProps = Omit<FieldBaseProps, 'titleAs' | 'inputId'>;

const Content = styled.div`
  ${tokens.flexContainer('form', { gap: tokens.spacer.x1pt5 })};
`;

/**
 * FieldList component
 *
 * {@link https://zeroheight.com/76c439891/p/368591-forms Usage guidelines}
 *
 * {@link https://storybook.hotjar.com/?path=/docs/components-field--basic-field Code documentation}
 *
 * @example
 * <FieldList labelText="My label">
 *  <Checkbox name="options" labelText="Option 1" />
 *  <Checkbox name="options" labelText="Option 2" />
 * </FieldList>
 */
export const FieldList = forwardRef<HTMLDivElement, FieldListProps>(
  ({ children, ...props }: FieldListProps, ref) => {
    return (
      <FieldBase ref={ref} titleAs="legend" {...props}>
        <Content>{children}</Content>
      </FieldBase>
    );
  },
);

FieldList.displayName = 'FieldList';

FieldList.defaultProps = {
  isRequired: false,
  isInvalid: false,
  showInvalidIcon: true,
  size: 'm',
};
